export function studentStudyDate(
  value: string,
  language: string,
  today: string,
  yesterday: string,
): string {
  const date = new Date(value);
  const now = new Date();
  const previous = new Date(now);
  previous.setDate(previous.getDate() - 1);
  const time = date.toLocaleTimeString(language, {
    hour: "2-digit",
    minute: "2-digit",
  });
  if (date.toDateString() === now.toDateString()) return `${today}, ${time}`;
  if (date.toDateString() === previous.toDateString())
    return `${yesterday}, ${time}`;
  return date.toLocaleString(language, {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    ...(date.getFullYear() !== now.getFullYear() ? { year: "numeric" } : {}),
  });
}
